<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item
                label="起止日期"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装/卸货点">
                <a-select v-model="queryParam.loadId" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in loadIdSelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装/卸货物">
                <a-select
                  showSearch
                  :filterOption="filterOption"
                  v-model="queryParam.materielId"
                  default-value="0"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in materielIdSelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装卸类型">
                <a-select v-model="queryParam.type" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button> -->
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>
    <!-- <div class="table-operator">
      <a-button style="margin-left: 0px" type="primary" @click="handleExport()">导出</a-button>
    </div>-->
    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1400 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDetail(record)">详情</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { codeList } from '@/api/sys'
import { loadVehiclePage, loadVehicleDelete, loadVehicleExport } from '@/api/logistics'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import { materielList, factoryLoadList } from '../../api/basic'
import storage from '@/utils/storage'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Bus from '@/layouts/bus'
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'LoacVehicle',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 表头
      columns: [
        {
          title: '物流单号',
          dataIndex: 'logisticsNo',
          width: '240px',
          fixed: 'left'
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '150px'
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          width: '210px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          width: '210px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '装卸货点',
          dataIndex: 'loadName',
          width: '150px'
        },
        {
          title: '货物',
          dataIndex: 'materielName',
          width: '270px'
        },
        {
          title: '装卸类型',
          dataIndex: 'typeName',
          width: '120px'
        },
        {
          title: '操作',
          width: '50px',
          fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }

        return loadVehiclePage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 装卸货点下拉
      loadIdSelect: null,
      // 装卸货物下拉
      materielIdSelect: null,
      // 装卸类型下拉
      typeSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()

    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {time:[moment().startOf('day'), moment().endOf('day')]}
    }else{
      this.queryParam.time[0] = moment(this.queryParam.time[0])
      this.queryParam.time[1] = moment(this.queryParam.time[1])
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = factoryLoadList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.loadIdSelect = res
      })
      new Promise(resolve => {
        const data = materielList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.materielIdSelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'logistics_load_vehicle_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDetail(record) {
      storage.save('cache-LoadVehicleDetail', JSON.stringify(record))
      this.$router.push({ name: 'LoadVehicleDetail' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
